export const P0003606SensContactEnum = [
  { ref: 0, label: 'P0003606.senscontact.0' },
  { ref: 1, label: 'P0003606.senscontact.1' },
  { ref: 99, label: 'generic.byprocedure' },
];
